<template>
    <v-card>
    <v-card-title>
      <v-toolbar  flat outlined>
     <v-toolbar-title>
         <v-icon large right>fas fa-user-tie</v-icon>
         Customers
    </v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      
        <v-btn  color="blue darken-3"  outlined @click="CreatenewCustomer()">
            <v-icon small left>fas fa-user-plus</v-icon>
            New Customer
        </v-btn>
      <v-spacer></v-spacer>
      
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-toolbar>
    </v-card-title>
        <v-data-table
        v-on:inseteCliente="getAllCustomers()"
        :headers="headers"
        :items="desserts"
        :search="search">
        <template v-slot:no-data v-if="desserts.length === 0">
                <v-progress-linear indeterminate color="blue darken-3" v-if="waiting"></v-progress-linear>
                <v-alert outlined class="text-xs-center" :value="true" type="warning" v-if="!waiting">No Data</v-alert>
            </template>
        <template v-slot:item.actions="{ item }">
            
            <v-tooltip bottom color="blue darken-2">
                <template v-slot:activator="{ on }">
                    <v-btn  @click="SeeCustomer(item)" x-small icon color="black" v-on="on">
                        <v-icon >fas fa-edit</v-icon>
                    </v-btn>
                </template>
                <span>Edit</span>
            </v-tooltip>
            <v-tooltip bottom color="blue darken-2">
                <template v-slot:activator="{ on }">
                    <v-btn  @click="deleteCustomer(item)" x-small icon color="black" v-on="on">
                        <v-icon >fas fa-trash-alt</v-icon>
                    </v-btn>
                </template>
                <span>Delete</span>
            </v-tooltip>
        </template>
        
        <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
            Your search "{{ search }}" not have result.
            </v-alert>
        </template>
        
        </v-data-table>
        
        <!--DIALOG TO INPUT TOTAL -->
        <v-dialog v-model="dialogCustomer" width="400" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  {{formTitle}}  Customer
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-text-field v-model="modelCustomer.name" :rules="nameRules" label="Name" required></v-text-field>
                        <v-text-field v-model="modelCustomer.address"   :rules="addressRules" label="Address" required ></v-text-field>
                        <v-text-field v-model="modelCustomer.postalCode"  :rules="requireRule" label="Postal Code" required ></v-text-field>
                        <v-text-field v-model="modelCustomer.phoneNumer"  :rules="phoneRules" label="Phone Number" required ></v-text-field>
                        <v-text-field v-model="modelCustomer.email"  :rules="requireRule" label="Email" required ></v-text-field>
                        <v-text-field type="number" v-model="modelCustomer.rate"  :rules="requireRule" label="Rate" required ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="closeDialog()" outlined>
                    <v-icon left>
                        cancel
                    </v-icon>
                    Cancel
                </v-btn>
                <v-btn color="blue darken-3" text @click="saveCustomer()" outlined>
                    <v-icon left>
                        save
                    </v-icon>
                    {{ButtonTitle}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import {showMessageError,showMessageSuccess,showMessageWarning} from '../../services/sweetAlert'
import Swal from 'sweetalert2'
export default {
    data() {
        return {
            dialogCustomer:false,
            waiting:true,
            dialogTotal: false,
            search: '',
            desserts:[],
            headers: [
                { text: 'Customer Name', align: 'left', value: 'name'},
                { text: 'Address', align: 'center',  value: 'address' },
                {text: 'Phone Number', align:'center', value: 'phoneNumer'},
                {text: 'Email', align:'center', value: 'email'},
                {text: 'Postal Code', align:'center', value: 'postalCode'},
                {text: 'Rate', align:'center', value: 'rate'},
                { text: 'Actions', value: 'actions',align: 'registerDate', sortable: false }
            ],
            editedIndex: -1,
            //form
            valid: true,
            name: '',
            requireRule:[
                v => !!v || 'Name is required'
            ],
            nameRules: [
                v => !!v || 'Name is required',
            ],
            address: '',
            addressRules: [
                v => !!v || 'Address is required',
            ],
            phoneNumber:'',
            phoneRules: [
                v => !!v || 'Phone Number is required',
            ],
            modelCustomer:{
                'name': '',
                'address': '',
                'phoneNumer': '',
                email:'',
                postalCode: '',
                rate:0
            }
        }
    },
    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'Add' : 'Edit'
        },
        ButtonTitle (){
            return this.editedIndex === -1 ? 'Save' : 'Update'
        }
    },
    mounted() {
        this.getAllCustomers()
    },
    methods: {
        async saveCustomer(){
            if(this.$refs.form.validate()){
                if(this.ButtonTitle === 'Save'){
                    return await this.registerCustomer()
                }else{
                    return await this.updateCustomer()
                }
            }
        },
        async updateCustomer(){
            const data = [
                { "value": this.modelCustomer.name, "path": "name", "op": "replace"},
                { "value": this.modelCustomer.address, "path": "address", "op": "replace"},
                { "value": this.modelCustomer.phoneNumer, "path": "phoneNumer", "op": "replace"},
                { "value": this.modelCustomer.email, "path": "email", "op": "replace"},
                { "value": this.modelCustomer.postalCode, "path": "postalCode", "op": "replace"},
                { "value": this.modelCustomer.rate, "path": "rate", "op": "replace"}
            ]
            var info = {id: this.editedIndex,data:data}
            //console.log('id customer ==> ', this.editedIndex)
            const response = await this.$store.dispatch('updateCustomer',info)
            if(response.status === 200){
                showMessageSuccess('Good !', 'Customer updated correctly')
                this.getAllCustomers()
                this.closeDialog()
            }else{
                showMessageError('An errorr ocurred')
            }
        },
        async registerCustomer(){
            const response = await this.$store.dispatch('CreateNewCustomer',this.modelCustomer)
            if(response.status === 200){
                showMessageSuccess('Good !', 'Customer added correctly')
                this.getAllCustomers()
                this.closeDialog()
            }else{
                showMessageError('An errorr ocurred')
            }
        },
        closeDialog(){
            this.dialogCustomer = false
             this.$refs.form.reset()
             this.$refs.form.resetValidation()
        },
        CreatenewCustomer(){
            this.editedIndex = -1
            this.dialogCustomer=true
        },
        async getAllCustomers(){
            this.desserts =[]
            this.waiting = true
            const response = await this.$store.dispatch('getAllCustomers')
            if(response.status === 200 ){
                this.desserts  = response.data
                this.waiting = false
            }else{
                showMessageError('An error occurred while loading customers')
            }
        },
        deleteCustomer(customer){
            const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
                buttonsStyling: true
            })

            swalWithBootstrapButtons.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
                reverseButtons: true
                }).then(async(result) => {
                if (result.isConfirmed) {
                    const response = await this.$store.dispatch('deleteCustomer', customer.idCustomer)
                    if(response){
                        swalWithBootstrapButtons.fire('Deleted!','Customer deleted successfully','success')
                        this.getAllCustomers()
                    }else{
                        showMessageError('An error ocurred')
                    }
                }
            })
        },
        SeeCustomer(item){
            //console.log('item => ', item)
            this.dialogCustomer=true
            this.editedIndex = item.idCustomer
            this.modelCustomer = Object.assign({}, item)
        }
    },
}
</script>